import { useEffect, useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Divider,
  Box,
  Card,
  CardContent,
  Avatar,
  Button,
  LinearProgress,
  useMediaQuery,
  Grid2,
} from "@mui/material";
import {
  AccountCircle,
  Business,
  Settings,
  Menu as MenuIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import Moment from "moment";
import { useOrders } from "../../../hooks/useOrdersProviders/OrdersContext";
import { useTheme } from "@mui/material/styles";

import { useDispatch, useSelector } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { useNavigate } from "react-router-dom";
import { useLoadScript } from "@react-google-maps/api";
import useObtenerDetallesdecuenta from "../../../hooks/obtenerDetallesdecuenta";
import useObtenerBalance from "../../../hooks/obtenerBalance";
import AccountProfileDetails from "./Form_micuenta";
import { OpcionesLaterales } from "./OpcionesLaterales";
import { UserContext } from "../../../context/CurrentUserProvider";
import PerfilDetalle from "./PerfilDetalle";
import CompanyDetailsCard from "./CompanyDetailsCard";
import ResumenServices from "./ResumenServices";
import { cerrarSesionAccion } from "../../../redux/usuarioDucks";

const DRAWER_WIDTH = 240;
const libraries = ["places"];

const VIEWS = {
  PROFILE: "Perfil",
  COMPANY: "Empresa",
  SERVICES: "Servicios",
};

const Micuenta = (props) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS_MATRIX,
    libraries,
  });

  const dispatch = useDispatch();

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const navigate = useNavigate();
  const userUid = useSelector((store) => store.usuario.user.uid);
  const [userData, setUserData] = useState(null);
  const [avatar, setAvatar] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [selectedView, setSelectedView] = useState(VIEWS.PROFILE);

  const { accountDetails, availableservices, loadingDetallesdecuenta } =
    useObtenerDetallesdecuenta(userData?.userCompanyID);

  const { userBalance, loadingBalance } = useObtenerBalance(
    userData?.userCompanyID,
  );

  const { userDataContext } = useContext(UserContext);

  const {
    mergedOrders,
    loadingContext,
    initDate,
    endDate,
    setInitDate,
    setEndDate,
    companiesData,
    setShouldSubscribe,
  } = useOrders({
    initDateInitial: Moment().format("YYYY-MM-DD"),
    endDateInitial: Moment().format("YYYY-MM-DD"),
  });

  // console.log("userData", userData);
  // console.log("userDataContext", userDataContext);
  // console.log(loadingContext);
  // console.log("Ordenes", mergedOrders);
  // console.log(companiesData);

  useEffect(() => {
    if (userUid) {
      getUserData(userUid);
    }
  }, []);

  const getUserData = async (uid) => {
    const userDoc = await getDoc(
      doc(db, `${process.env.REACT_APP_COL_USERS}/${uid}`),
    );
    if (userDoc.exists()) {
      const data = userDoc.data();
      setUserData(data);
      setAvatar(data.avatar);
      setDisplayName(data.userName);
    }
  };

  const menuItems = [
    { id: VIEWS.PROFILE, text: "Perfil", icon: <AccountCircle /> },
    { id: VIEWS.COMPANY, text: "Empresa", icon: <Business /> },
    { id: VIEWS.SERVICES, text: "Servicios", icon: <Settings /> },
  ];

  const drawer = (
    <div>
      <Grid2
        sx={{
          margin: "3px",
          display: "flex-colum",
          backgroundColor: "#f8f8f8",
        }}
      >
        <Grid2 item xs={12}>
          <Toolbar sx={{ justifyContent: "center" }}>
            <Typography variant="h6">Mi Cuenta</Typography>
          </Toolbar>
        </Grid2>

        <Divider />
        <List>
          {menuItems.map(({ id, text, icon }) => (
            <ListItem key={id} disablePadding>
              <ListItemButton
                selected={selectedView === id}
                onClick={() => {
                  setSelectedView(id);
                  if (!isMdUp) setMobileOpen(false);
                }}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => cerrarSesion()}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Salir" />
            </ListItemButton>
          </ListItem>
        </List>
      </Grid2>
    </div>
  );

  const cerrarSesion = () => {
    dispatch(cerrarSesionAccion());
  };

  const renderContent = () => {
    switch (selectedView) {
      case VIEWS.PROFILE:
        return userDataContext ? (
          <PerfilDetalle
            userData={userDataContext.userData}
            companyData={userDataContext.companyData}
          />
        ) : (
          <LinearProgress />
        );
      case VIEWS.COMPANY:
        return (
          <Box sx={{ p: 2 }}>
            {!userData.userCompanyID ? (
              <Card sx={{ mt: 2 }}>
                <CardContent sx={{ textAlign: "center" }}>
                  {userData?.companyImgLogo ? (
                    <>
                      <Avatar
                        src={
                          userData?.companyImgLogo
                            ? userData?.companyImgLogo
                            : ""
                        }
                        sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
                      />
                      <Typography variant="h6">
                        {userData.companyRegion}, {userData.companyCity}
                      </Typography>
                      <Typography color="textSecondary">
                        {userData.companyRut}
                      </Typography>
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => navigate("/dashboard/companies")}
                    >
                      Crear Empresa
                    </Button>
                  )}
                </CardContent>
              </Card>
            ) : null}

            <Box sx={{ mt: 2 }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Empresa Principal
              </Typography>
              <CompanyDetailsCard company={userDataContext.companyData} />
              <Typography variant="h5" sx={{ mb: 2 }}>
                Colaboraciones
              </Typography>
              <Divider sx={{ my: 2 }} />
              {companiesData ? (
                <>
                  {companiesData?.map((collab, index) => (
                    <CompanyDetailsCard key={index} company={collab} />
                  ))}
                </>
              ) : null}
            </Box>
          </Box>
        );
      case VIEWS.SERVICES:
        return availableservices ? (
          <ResumenServices
            serviciosAct={availableservices}
            mergedOrders={mergedOrders}
          />
        ) : loadingDetallesdecuenta ? (
          <LinearProgress />
        ) : (
          <Box
            sx={{
              textAlign: "center",
              p: 2,
              border: "1px solid #eee",
              borderRadius: "8px",
              bgcolor: "#8f130c",
              color: "white",
            }}
          >
            <Typography variant="body2">
              Requiere registro de su empresa.
            </Typography>
          </Box>
        );

      default:
        return null;
    }
  };

  if (loadError) return "Error al cargar Google Maps";
  if (!isLoaded) return "Cargando...";

  return userData ? (
    <Grid2
      sx={{
        margin: "3px",
        display: "flex-colum",
        backgroundColor: "#f8f8f8",
        height: "100vh",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      <Grid2 item xs={12}>
        <AppBar
          position="realative"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            bgcolor: "#f8f8f8",
            color: "#333",
          }}
        >
          <Toolbar>
            {!isMdUp && (
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" noWrap>
              {selectedView}
            </Typography>
          </Toolbar>
        </AppBar>
      </Grid2>
      <Grid2
        sx={{
          display: "flex",
        }}
      >
        <Grid2
          item
          xs={12}
          sx={{
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%",
              lg: "25%",
              xl: "25%",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            {/* Drawer Lateral */}
            {!isMdUp ? (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{ "& .MuiDrawer-paper": { width: DRAWER_WIDTH } }}
              >
                {drawer}
              </Drawer>
            ) : (
              <Drawer
                variant="permanent"
                open // ← sigue siendo “permanente”
                //    disablePortal // ← evita que se salga al <body>
                sx={{
                  // ← estilos al contenedor raíz
                  position: "relative", //   deja de ser fixed
                  flexShrink: 0,
                  width: "100%",
                }}
                PaperProps={{
                  sx: {
                    position: "relative", // ← hoja interna también relativa
                    width: "100%",
                    boxSizing: "border-box",
                  },
                }}
              >
                {drawer}
              </Drawer>
            )}
          </Box>
        </Grid2>
        <Grid2
          sx={{
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%",
              lg: "70%",
              xl: "70%",
            },
          }}
        >
          {renderContent()}
          {/* <Fromcompanywiew company={companyData} userUid={userData.uid} /> */}
        </Grid2>
      </Grid2>
    </Grid2>
  ) : (
    <LinearProgress />
  );
};

export default Micuenta;
